import styled from "styled-components";
import Swal from "sweetalert2";
import { getThemeColor } from "./themeConfig";

const REDIRECT_WHATSAPP = process.env.REACT_APP_REDIRECT_WHATSAPP_EXPIRE;

export const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "2000",
  },
  content: {
    backgroundColor: getThemeColor("--color-bg") || "#f5f0eb",
    overflow: "auto",
    padding: "32px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "600px",
    maxHeight: "85vh",
    margin: "auto",
    border: "none",
    boxShadow: "0 25px 60px rgba(0, 0, 0, 0.25)",
    transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    inset: "auto",
    position: "relative",
  },
};

export const StyledInput = styled.input`
  width: 48px;
  height: 36px;
  padding: 4px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background-color: var(--color-surface);
  color: var(--color-text);
  -moz-appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border-color: var(--color-primary);
    outline: none;
    box-shadow: 0 0 0 3px rgba(230, 57, 70, 0.1);
  }
`;

// Progress bar styles
const style_alert_whatsap = document.createElement("style");
style_alert_whatsap.innerHTML = `
  .progress-bar-container {
    position: relative;
    width: 100%;
    height: 6px;
    background-color: var(--color-border);
    border-radius: 999px;
    overflow: hidden;
    margin-top: 20px;
  }
  .progress-bar {
    position: absolute;
    width: 0;
    height: 100%;
    background: var(--color-primary-gradient);
    border-radius: 999px;
    animation: progressBarAnimation 2s infinite;
  }
  @keyframes progressBarAnimation {
    0% { width: 0; }
    100% { width: 100%; }
  }
  .swal2-toast-custom {
    font-family: var(--font-family) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  }
`;
document.head.appendChild(style_alert_whatsap);

export const MessageAlertTokenExpire = () => {
  const primary = getThemeColor("--color-primary") || "#e63946";
  const secondary = getThemeColor("--color-secondary") || "#f4a261";
  const textSecondary = getThemeColor("--color-text-secondary") || "#6b7280";

  Swal.fire({
    icon: "info",
    title: "Tu sesión ha caducado",
    html: `
      <p style="color: ${textSecondary}; font-size: 14px; margin-bottom: 16px;">Por favor, genera uno nuevo para continuar.</p>
      <button id="generate-menu-btn" class="swal2-confirm swal2-styled" style="
        background: linear-gradient(135deg, ${primary}, ${secondary});
        border: none;
        padding: 12px 28px;
        border-radius: 12px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        color: white;
        transition: all 0.25s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      ">Generar menú</button>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    customClass: {
      popup: "swal2-toast-custom",
    },
    didRender: () => {
      document
        .getElementById("generate-menu-btn")
        .addEventListener("click", () => {
          window.location.href = REDIRECT_WHATSAPP;
        });
    },
  });
};

export const MessageAlertMissingPhone = () => {
  const primary = getThemeColor("--color-primary") || "#e63946";
  const secondary = getThemeColor("--color-secondary") || "#f4a261";
  const textSecondary = getThemeColor("--color-text-secondary") || "#6b7280";

  Swal.fire({
    icon: "info",
    title: "Falta el numero del cliente",
    html: `
      <p style="color: ${textSecondary}; font-size: 14px; margin-bottom: 16px;">El carrito no trae un telefono valido para iniciar el pedido por WhatsApp.</p>
      <button id="generate-menu-btn" class="swal2-confirm swal2-styled" style="
        background: linear-gradient(135deg, ${primary}, ${secondary});
        border: none;
        padding: 12px 28px;
        border-radius: 12px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        color: white;
        transition: all 0.25s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      ">Volver al chat</button>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    customClass: {
      popup: "swal2-toast-custom",
    },
    didRender: () => {
      document
        .getElementById("generate-menu-btn")
        .addEventListener("click", () => {
          window.location.href = REDIRECT_WHATSAPP;
        });
    },
  });
};
